/* ── ElShowTCG Cart Drawer ─────────────────────────────────── */
(function () {
  'use strict';



  /* ── Helpers ─────────────────────────────────────────────── */
  function money(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  async function fetchCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }

  /* ── Counter ─────────────────────────────────────────────── */
  async function updateCartCount() {
    const cart = await fetchCart();
    const badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    const drawerCount = document.getElementById('drawer-count');
    if (drawerCount) drawerCount.textContent = cart.item_count;
    return cart;
  }

  /* ── Drawer open/close ───────────────────────────────────── */
  function openDrawer() {
    document.getElementById('cart-drawer')?.classList.add('active');
    document.getElementById('cart-overlay')?.classList.add('active');
    document.body.style.overflow = 'hidden';
    loadCartItems();
  }

  function closeDrawer() {
    document.getElementById('cart-drawer')?.classList.remove('active');
    document.getElementById('cart-overlay')?.classList.remove('active');
    document.body.style.overflow = '';
  }

  document.getElementById('cart-toggle')?.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
  document.getElementById('cart-close')?.addEventListener('click', closeDrawer);
  document.getElementById('cart-overlay')?.addEventListener('click', closeDrawer);

  /* ── Articulos a 0,00 € ──────────────────────────────────────
     Un articulo sin precio no se puede comprar. La tarjeta y la ficha ya lo
     bloquean, pero uno pudo entrar al carrito antes o quedarse de una sesion
     vieja: aqui se desactiva el paso a pago mientras siga dentro.          */
  function marcarSinPrecio(cart) {
    const hay = (cart.items || []).some(i => !i.price);
    const aviso = document.getElementById('cart-drawer-blocked');
    const boton = document.getElementById('cart-drawer-checkout');
    if (aviso) aviso.hidden = !hay;
    if (boton) {
      boton.classList.toggle('btn-checkout--disabled', hay);
      boton.setAttribute('aria-disabled', hay ? 'true' : 'false');
      if (hay) {
        boton.removeAttribute('href');
      } else {
        boton.setAttribute('href', '/checkout');
      }
    }
  }

  /* ── Load cart items into drawer ─────────────────────────── */
  async function loadCartItems() {
    const cart = await fetchCart();
    const container = document.getElementById('cart-drawer-items');
    const subtotalEl = document.getElementById('cart-subtotal-price');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    marcarSinPrecio(cart);

    if (!container) return;

    if (cart.items.length === 0) {
      container.innerHTML = `
        <div class="cart-empty">
          <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#C0392B" stroke-width="1.5">
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          <p>Tu carrito está vacío</p>
          <a href="/collections/all" class="btn-hero-primary" style="font-size:14px;padding:12px 24px">Ver colección →</a>
        </div>`;
      return;
    }

    container.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <a href="${item.url}" class="cart-item-image">
          <img src="${item.featured_image?.url || item.image || ''}" alt="${item.title}" width="72" height="96" loading="lazy" style="width:72px;height:96px;object-fit:cover;border-radius:8px">
        </a>
        <div class="cart-item-info">
          <a href="${item.url}" class="cart-item-title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
          <p class="cart-item-price">${money(item.price)}</p>
          <div class="cart-item-actions">
            <div class="qty-control">
              <button class="qty-btn qty-minus" data-key="${item.key}" aria-label="Reducir">−</button>
              <span class="qty-value">${item.quantity}</span>
              <button class="qty-btn qty-plus" data-key="${item.key}" aria-label="Aumentar">+</button>
            </div>
            <button class="cart-item-remove" data-key="${item.key}" aria-label="Eliminar">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `).join('');

    bindItemEvents(container);
  }

  function bindItemEvents(container) {
    container.querySelectorAll('.qty-plus').forEach(btn => {
      btn.addEventListener('click', () => changeQty(btn.dataset.key, 1));
    });
    container.querySelectorAll('.qty-minus').forEach(btn => {
      btn.addEventListener('click', () => changeQty(btn.dataset.key, -1));
    });
    container.querySelectorAll('.cart-item-remove').forEach(btn => {
      btn.addEventListener('click', () => removeItem(btn.dataset.key));
    });
  }

  async function changeQty(key, delta) {
    const cart = await fetchCart();
    const item = cart.items.find(i => i.key === key);
    if (!item) return;
    const newQty = Math.max(0, item.quantity + delta);
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    loadCartItems();
    updateCartCount();
  }

  async function removeItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    loadCartItems();
    updateCartCount();
  }

  /* ── Shipping bar ────────────────────────────────────────── */

  /* ── Add to cart — product cards ─────────────────────────── */
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;
    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    const qtyEl = form.querySelector('[name="quantity"]');
    const quantity = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;

    const originalHTML = btn?.innerHTML;
    if (btn) { btn.textContent = '...'; btn.disabled = true; }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });

      if (res.ok) {
        updateCartCount();
        openDrawer();
        if (btn) {
          btn.textContent = '✓ Añadido';
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
            if (window.lucide) window.lucide.createIcons();
          }, 2000);
        }
      } else {
        throw new Error('Error');
      }
    } catch {
      if (btn) { btn.innerHTML = originalHTML; btn.disabled = false; if (window.lucide) window.lucide.createIcons(); }
    }
  });

  /* ── Init ────────────────────────────────────────────────── */
  updateCartCount();

  /* Expose for product page */
  window.updateCart = updateCartCount;
  window.openCartDrawer = openDrawer;
  /* Para la casilla de proteccion: refrescar el cajon SIN recargar la pagina,
     que recargando se cerraba solo. */
  window.ElShowCarrito = {
    recargar: function () { loadCartItems(); updateCartCount(); },
    abrir: openDrawer,
    cerrar: closeDrawer
  };

})();
